import { render, staticRenderFns } from "./StatusChip.vue?vue&type=template&id=56e7fc1f&scoped=true"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"
import style0 from "./StatusChip.vue?vue&type=style&index=0&id=56e7fc1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e7fc1f",
  null
  
)

export default component.exports